import {fetchWithAuth} from '../util/fetch';
import {UserManagerApiEndpointURL} from '../constants';
import {idMap} from '../util/idMap';
import {actionFactory} from '../util/redux-helpers';

export const ACTIONS = {

  LoadUsersInProgress: 'usersEndpoint/LOAD_USERS_INPROGRESS',
  LoadUsersFailed: 'usersEndpoint/LOAD_USERS_FAILED',
  LoadUsersCompleted: 'usersEndpoint/LOAD_USERS_COMPLETED',

  AddUserInProgress: 'usersEndpoint/ADD_USER_INPROGRESS',
  AddUserCompleted: 'usersEndpoint/ADD_USER_COMPLETED',
  AddUserCompletedWithError: 'usersEndpoint/ADD_USER_COMPLETED_WITH_ERROR',
  AddUserFailed: 'usersEndpoint/ADD_USER_FAILED',

  DisableUserInProgress: 'usersEndpoint/DISABLE_USER_INPROGRESS',
  DisableUserCompleted: 'usersEndpoint/DISABLE_USER_COMPLETED',
  DisableUserFailed: 'usersEndpoint/DISABLE_USER_FAILED',

  EnableUserInProgress: 'usersEndpoint/ENABLE_USER_INPROGRESS',
  EnableUserCompleted: 'usersEndpoint/ENABLE_USER_COMPLETED',
  EnableUserFailed: 'usersEndpoint/ENABLE_USER_FAILED',

  UnlockUserInProgress: 'usersEndpoint/UNLOCK_USER_IN_PROGRESS',
  UnlockUserCompleted: 'usersEndpoint/UNLOCK_USER_COMPLETED',
  UnlockUserFailed: 'usersEndpoint/UNLOCK_USER_FAILED',
}

const LoadUsersInProgress = actionFactory(ACTIONS.LoadUsersInProgress);
const LoadUsersFailed = actionFactory(ACTIONS.LoadUsersFailed);
const LoadUsersCompleted = actionFactory(ACTIONS.LoadUsersCompleted);

const AddUserInProgress = actionFactory(ACTIONS.AddUserInProgress);
const AddUserCompleted = actionFactory(ACTIONS.AddUserCompleted);
const AddUserCompletedWithError = actionFactory(ACTIONS.AddUserCompletedWithError);
const AddUserFailed = actionFactory(ACTIONS.AddUserFailed);

// const DisableUserInProgress = action(ACTIONS.DisableUserInProgress);
// const DisableUserCompleted = action(ACTIONS.DisableUserCompleted);
// const DisableUserFailed = action(ACTIONS.DisableUserFailed);

// const EnableUserInProgress = action(ACTIONS.EnableUserInProgress);
// const EnableUserCompleted = action(ACTIONS.EnableUserCompleted);
// const EnableUserFailed = action(ACTIONS.EnableUserFailed);

// const UnlockUserInProgress = action(ACTIONS.UnlockUserInProgress);
// const UnlockUserCompleted = action(ACTIONS.UnlockUserCompleted);
// const UnlockUserFailed = action(ACTIONS.UnlockUserFailed);

export function LoadUsersEpic(companyId) {
   return async (dispatch) => { //redux-thunk middleware for async dispatching support
     try{
       dispatch(LoadUsersInProgress());
        const usersResponse = await fetchWithAuth(`${UserManagerApiEndpointURL}/Entities(${companyId})/Users`);
        if (usersResponse){
          if (usersResponse.status === 200) {
            let userObjects = await usersResponse.json();
            dispatch(LoadUsersCompleted(idMap(userObjects.items,"Id")));
          } else {
            dispatch(LoadUsersFailed(await usersResponse.text()));
          }
        } else {
          dispatch(LoadUsersFailed('No response received from server'));
        }
    } catch (err) {
      dispatch(LoadUsersFailed(err));
    }
  }
}

export function LoadLocationUsersEpic(companyId, locationId) {
   return async (dispatch) => { //redux-thunk middleware for async dispatching support
     try{
       dispatch(LoadUsersInProgress());
        const usersResponse = await fetchWithAuth(`${UserManagerApiEndpointURL}/Entities(${companyId})/Users`);
        if (usersResponse){
          if (usersResponse.status === 200) {
            let userObjects = await usersResponse.json();
            let filteredUsers = [];
            for(let i = 0; i < userObjects.items.length; i++){
              let userLocs = await loadUserLocations(userObjects.items[i]);
              if (userLocs && userLocs.LocationIDs && userLocs.LocationIDs.indexOf(locationId) !== -1){
                userObjects.items[i].locationId = locationId;
                filteredUsers.push(userObjects.items[i]);
              }
            }
            dispatch(LoadUsersCompleted(idMap(filteredUsers,"Id")));

          } else {
            dispatch(LoadUsersFailed(await usersResponse.text()));
          }
        } else {
          dispatch(LoadUsersFailed('No response received from server'));
        }
    } catch (err) {
      dispatch(LoadUsersFailed(err));
    }
  }
}

export function AddLocationUserEpic(companyId, locationId, userRecord) {
  return async (dispatch) => {
    dispatch(AddUserInProgress());

    let createResponse = await fetchWithAuth(`${UserManagerApiEndpointURL}/Users`, {
      method: 'POST',
      body: JSON.stringify({
        UserName: userRecord.userName,
        Email: userRecord.email,
        FirstName: userRecord.firstName,
        LastName: userRecord.lastName,
        ParentEntityId: companyId
      })
    });
    if (createResponse.status === 201) { //Created Success
      let newUser = await createResponse.json();
      //Associate Location with new user
      let assignResponse = await fetchWithAuth(`${UserManagerApiEndpointURL}/Users(${newUser.Id})/Locations(${locationId})`, {
        method: 'PUT'
      });
      if (assignResponse.status === 204) { //204 No Content on success {
        newUser.locations = [locationId];
        dispatch(AddUserCompleted(newUser));
      } else {
        dispatch(AddUserCompletedWithError({ user: newUser, error: "User created but was not added to a location. See 'All Users' list"}));
      }
    } else {
      dispatch(AddUserFailed(await createResponse.text()));
    }
  }
}


async function loadUserLocations(user){
  return fetchWithAuth(`${UserManagerApiEndpointURL}/Users(${user.Id})/Locations`)
    .then(result => result.status === 200? result.json():null);
}


// WEBPACK FOOTER //
// ./src/actions/users.actions.js